import React, { useState } from "react";
import "./testimonial.css";
import BVCITS from "../../assets/Testimonials/BVCITS1.png";
import RVITIMG from "../../assets/Testimonials/RVITIMG.png";
import swarnadara from "../../assets/Testimonials/Swarnadara.png";
import vignanimg from "../../assets/Testimonials/vignanimg.png";

const Testimonial = () => {
  const Testimonal = [
    {
      contant:
        "“Exceptional results! Aspiron transformed our operations with innovative software, creating a unified platform for seamless management. Their ongoing support ensures our institution stays ahead in education technology.”",
      Image: BVCITS,
      name: "Sri Bonam Krishna Satish",
      designation: "CEO of",
      collegename:
        "Bonam Venkata Chalamayya Institute of Technology and Science, East Godavari.",
      shadow: "1px 1px 0px yellow",
    },
    {
      contant:
        "“We are beyond impressed with Aspiron’s educational solutions. The software's adaptability to our unique needs and their ongoing commitment to excellence have elevated our institution's efficiency and innovation.”",
      Image: RVITIMG,
      name: "Dr. R V Krishnaiah",
      designation: "Chairman of",
      collegename: "RV institute of technology, Guntur District",
      shadow: "1px 1px 0px gold",
      top: "1.5cm",
    },
    {
      contant:
        "“Efficiency redefined! Aspiron has transformed our school's operations. Their comprehensive software suite has not only simplified tasks but also improved communication, making teaching and learning a seamless experience.”",
      Image: vignanimg,
      name: "Dr. G. Durga Sukumar Ph.D (IIT-R)",
      designation: "Principal of",
      collegename:
        "Vignan Institute of Technology and Science, Yadadri-Bhuvanagiri District.",
     
      shadow: "1px 1px 0px gold",
    },
    {
      contant:
        "“Outstanding commitment! Aspiron understands the unique needs of educational institutions, offering comprehensive software solutions that consolidate processes. Their responsive support ensures a smooth experience. Highly recommended!”",
      Image: swarnadara,
      name: "Dr. A Gopichand M.Tech, Ph.D",
      designation: "Vice - Principal of",
      collegename:
        "Swarnandhra College of Engineering and Technology, Narasapur.",
      shadow: "1px 1px 0px gold",
      top: "1.5cm",
    },
  ];

  const [selectedTestimonial, setSelectedTestimonial] = useState(Testimonal[0]);


  return (
    <div
      style={{ padding: "1rem 0",}}
      className="testmonial_bck"
    >
      {/* <h1 style={{ color: "#FF9800", textAlign: "center" }}>Testimonials</h1> */}

      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "50px",
            lineHeight: "60px",
          }}
        >
          Our Client <span style={{ fontWeight: 100 }}>Testimonials</span>
          <br />
          Here what <span style={{ fontWeight: 100 }}>they say:</span>
        </h2>
      </div><br/>

      {/* <Slider {...settings}> */}
      <div style={{
          display: "flex",
          // flexDirection:"column",
          textAlign: "center",
          justifyContent:"center",
          // width: "50%",
          // marginLeft: "10cm",
        }}>
      <div
        style={{
          display: "flex",
          textAlign: "center",
          justifyContent:"center",
          // width: "50%",
         
        }}
      >
        {Testimonal.map((item, index) => (
          <div
            key={index}
            className="testimonial_img"
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              margin: "1px",
              // padding:"10px",
              marginTop: item?.top,
              width: "100%",
            }}
          >
            <img
              data-aos-delay="100"
              data-aos="fade-down"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="800"
              src={item.Image}
              alt={item.name}
              className="TEST_img"
              style={{
                boxShadow:
                  selectedTestimonial.name === item.name
                    ? "gold 0px 1px 2px 0px, gold 0px 2px 6px 5px"
                    : "",
              }}
              // className={item === selectedTestimonial ? "selected" : ""}
              onClick={() => setSelectedTestimonial(item)}
            />
          </div>
        ))}
      </div>
      </div>
      
     
      <br />
      <br />
      {/* <div style={{ alignItems: "center", textAlign: "center" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          sx={{ color: "#FF9800",fontSize:"40px" }}
          style={{
            translate: "none",
            rotate: "none",
            scale: "none",
            transform: "translate(0px, 0px)",
            opacity: 1,
            width: "24px", // Adjust size as needed
            height: "24px",
            margin: "auto",
          }}
        >
          <path
            d="M 13.5 10 A 8.5 8.5 0 0 0 13.5 27 A 8.5 8.5 0 0 0 18.291016 25.519531 C 17.422273 29.222843 15.877848 31.803343 14.357422 33.589844 C 12.068414 36.279429 9.9433594 37.107422 9.9433594 37.107422 A 1.50015 1.50015 0 1 0 11.056641 39.892578 C 11.056641 39.892578 13.931586 38.720571 16.642578 35.535156 C 19.35357 32.349741 22 27.072581 22 19 A 1.50015 1.50015 0 0 0 21.984375 18.78125 A 8.5 8.5 0 0 0 13.5 10 z M 34.5 10 A 8.5 8.5 0 0 0 34.5 27 A 8.5 8.5 0 0 0 39.291016 25.519531 C 38.422273 29.222843 36.877848 31.803343 35.357422 33.589844 C 33.068414 36.279429 30.943359 37.107422 30.943359 37.107422 A 1.50015 1.50015 0 1 0 32.056641 39.892578 C 32.056641 39.892578 34.931586 38.720571 37.642578 35.535156 C 40.35357 32.349741 43 27.072581 43 19 A 1.50015 1.50015 0 0 0 42.984375 18.78125 A 8.5 8.5 0 0 0 34.5 10 z"
            fill="#FF9800"
          ></path>
        </svg>
      </div> */}
      <h1 style={{textAlign:"center",color:"#FF9800",fontSize:"90px",lineHeight:"5px",letterSpacing:"-5px"}}>❜❜</h1>
      
      <div
        data-aos-delay="100"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-easing="ease-in-sine"
        data-aos-duration="800"
        style={{
          marginTop: "2rem",
          backgroundColor: "transperent",
          padding: "20px",
          borderRadius: "10px",
          width: "70%",
          margin: "auto",
          color: "black",
          textAlign: "center",
        }}
      >
        <blockquote
          style={{
            color: "black",
            fontStyle: "italic",
            marginBottom: "1rem",
          }}
        >
          {selectedTestimonial.contant}
        </blockquote>
        <hr style={{ border: "1px solid black", margin: "20px 0" }} />
        <h5 style={{ color: "#FF9800" }}>{selectedTestimonial.name}</h5>
        <p>
          {selectedTestimonial.designation}
          <br />
          <span style={{}}>{selectedTestimonial.collegename}</span>
        </p>
      </div>
    </div>
  );
};

export default Testimonial;
